var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGolineeTear(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\uADF8\\uB8F9 353",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.762,
    height: 115.539,
    viewBox: "0 0 74.762 115.539",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "9yrqp7qsha"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 686",
    style: {
      fill: "none"
    },
    d: "M0 0h74.762v115.539H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3h1qmlctvb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 685",
    style: {
      fill: "none"
    },
    d: "M0 0h74.763v115.539H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ofzlw8kmec"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 684",
    style: {
      fill: "none"
    },
    d: "M0 0h73.997v31.885H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 351",
    style: {
      clipPath: "url(#9yrqp7qsha)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 350"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 349",
    style: {
      clipPath: "url(#3h1qmlctvb)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 348",
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 347"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 346",
    style: {
      clipPath: "url(#ofzlw8kmec)"
    },
    transform: "translate(.564 83.654)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 633",
    d: "M74.432 80.382c0 8.8-16.565 15.942-37 15.942s-37-7.137-37-15.942S17 64.44 37.433 64.44s37 7.137 37 15.942",
    transform: "translate(-.435 -64.439)",
    style: {
      fill: "#333"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 634",
    d: "M70.417 59.79a34.038 34.038 0 1 1-34.039-34.039A34.038 34.038 0 0 1 70.417 59.79",
    transform: "translate(.698 7.679)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 635",
    d: "M37.381 98.173a37.381 37.381 0 1 1 37.381-37.38 37.424 37.424 0 0 1-37.381 37.38m0-68.685a31.3 31.3 0 1 0 31.3 31.3 31.34 31.34 0 0 0-31.3-31.3",
    transform: "translate(0 6.981)",
    style: {
      fill: "#1a1e27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 636",
    d: "M34.738 59.1a2.432 2.432 0 0 1-2.432-2.432v-6.074a2.432 2.432 0 1 1 4.863 0v6.078a2.432 2.432 0 0 1-2.431 2.428",
    transform: "translate(9.633 14.361)",
    style: {
      fill: "#1a1e27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 637",
    d: "M41.293 57.293a2.432 2.432 0 0 1-2.432-2.432v-6.077a2.432 2.432 0 0 1 4.863 0v6.078a2.432 2.432 0 0 1-2.432 2.432",
    transform: "translate(11.588 13.822)",
    style: {
      fill: "#1a1e27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 638",
    d: "M25.981 36.684a3.039 3.039 0 0 1-3.039-3.039V22.7a3.039 3.039 0 1 1 6.078 0v10.945a3.039 3.039 0 0 1-3.039 3.039",
    transform: "translate(6.841 5.864)",
    style: {
      fill: "#1a1e27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 639",
    d: "M17.428 58.841c2.377 2.169 3.413 4.9 2.313 6.109s-3.918.423-6.295-1.746-3.413-4.9-2.313-6.109 3.918-.423 6.295 1.746",
    transform: "translate(3.189 16.856)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 640",
    d: "M18.365 66.333c2.377 2.169 3.413 4.9 2.313 6.109s-3.918.423-6.295-1.746-3.413-4.9-2.313-6.108 3.918-.425 6.295 1.745",
    transform: "translate(3.468 19.091)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 641",
    d: "M26.793 66.333c2.376 2.169 3.413 4.9 2.313 6.109s-3.918.423-6.3-1.746-3.413-4.9-2.313-6.108 3.918-.425 6.3 1.745",
    transform: "translate(5.981 19.091)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 642",
    d: "m15.451 7.249 12.156 20.666L40.98 6.034S34.9 1.171 27.607 2.386 15.451 4.817 15.451 7.249",
    transform: "translate(4.607 .653)",
    style: {
      fill: "#00dd4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 643",
    d: "M44.064 6.492C44.064 1.7 35.753 0 28.636 0s-15.43 1.7-15.43 6.492a3.775 3.775 0 0 0 .5 1.867 2.367 2.367 0 0 0 .215.541l11.266 20.116A3.954 3.954 0 0 0 28.621 31h.019a3.968 3.968 0 0 0 3.447-2.038L43.347 8.9a2.394 2.394 0 0 0 .217-.543 3.788 3.788 0 0 0 .5-1.867M28.636 4.862c4.953 0 8.4.9 9.921 1.631-1.518.736-4.968 1.631-9.921 1.631s-8.4-.894-9.922-1.631c1.518-.735 4.968-1.631 9.922-1.631m-1.073 18.444-6.134-10.954a39.519 39.519 0 0 0 7.208.634 39.642 39.642 0 0 0 7.2-.631l-6.153 10.953a1.216 1.216 0 0 1-2.121 0",
    transform: "translate(3.938)",
    style: {
      fill: "#1a1e27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 644",
    d: "M35.628 56.6a2.6 2.6 0 1 1-2.6-2.6 2.6 2.6 0 0 1 2.6 2.6",
    transform: "translate(9.075 16.102)",
    style: {
      fill: "#64d0ed"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolineeTear);
export default __webpack_public_path__ + "static/media/golinee_tear.8cb8048fa4c3945005de123b9c42bcfa.svg";
export { ForwardRef as ReactComponent };